import safePromoCleanerCloudDarkMp4 from 'img/safe/safePromoCleanerCloud_dark.mp4';
import safePromoCleanerCloudDarkWebm from 'img/safe/safePromoCleanerCloud_dark.webm';
import safePromoCleanerCloudLightMp4 from 'img/safe/safePromoCleanerCloud_light.mp4';
import safePromoCleanerCloudLightWebm from 'img/safe/safePromoCleanerCloud_light.webm';
import safePromoCleanerMailDarkMp4 from 'img/safe/safePromoCleanerMail_dark.mp4';
import safePromoCleanerMailDarkWebm from 'img/safe/safePromoCleanerMail_dark.webm';
import safePromoCleanerMailLightMp4 from 'img/safe/safePromoCleanerMail_light.mp4';
import safePromoCleanerMailLightWebm from 'img/safe/safePromoCleanerMail_light.webm';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { FastCleanerSafeModalProps } from './FastCleanerSafeModal';

export const renderFastCleanSafeModal = (data?: FastCleanerSafeModalProps) => {
    openPopupHelper({ popupName: popupNames.FAST_CLEANER_SAFE, data, onClose: data?.onClose });
};

export type VideoCoverImg = { webm: string; mp4: string };

export const fastCleanerSafeCoverConfig: {
    files: { dark: VideoCoverImg; light: VideoCoverImg };
    letters: { dark: VideoCoverImg; light: VideoCoverImg };
} = {
    letters: {
        dark: { webm: safePromoCleanerMailDarkWebm, mp4: safePromoCleanerMailDarkMp4 },
        light: { webm: safePromoCleanerMailLightWebm, mp4: safePromoCleanerMailLightMp4 },
    },
    files: {
        dark: { webm: safePromoCleanerCloudDarkWebm, mp4: safePromoCleanerCloudDarkMp4 },
        light: { webm: safePromoCleanerCloudLightWebm, mp4: safePromoCleanerCloudLightMp4 },
    },
};

export type FastCleanSafeModalCoverType = keyof typeof fastCleanerSafeCoverConfig;

export const getFastCleanSafeModalCoverImage = (coverType: FastCleanSafeModalCoverType): VideoCoverImg => {
    const isDarkTheme = isDarkThemeModeEnabled();

    const coverConfig = fastCleanerSafeCoverConfig[coverType] || fastCleanerSafeCoverConfig.files;

    return isDarkTheme ? coverConfig.dark : coverConfig.light;
};
